import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAuditRemarks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/audit_remarks", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addAuditRemark(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/audit_remarks", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteAuditRemark(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/audit_remarks", { params: data })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
